import moment from 'moment'
import Vue from 'vue'
import VueI18n from 'vue-i18n'


export const formatDuration = (value:number,i18n:VueI18n,forceShowSecond:boolean = false) => {
  if (value || value===0) {      
    const negatif = value < 0?"-":""
    const duration = moment.duration(Math.abs(value))
    const durationMs = duration.asMilliseconds()    

    if(isNaN(durationMs)) return ''
    
    if(durationMs >= 24 * 60 * 60 * 1000) return `${negatif}${duration.days()} ${i18n.t('Global.Days')} ${duration.hours()}h ${duration.minutes() > 0?`${duration.minutes()}min`:''}${forceShowSecond?(duration.seconds()> 0?`${duration.seconds()}s`:''):''}`
    else if(durationMs >= 60 * 60 * 1000) return `${negatif}${duration.hours()}h ${duration.minutes() > 0?`${duration.minutes()}min`:''}${forceShowSecond?(duration.seconds()> 0?`${duration.seconds()}s`:''):''}`
    else if(durationMs >= 60 * 1000) return `${negatif}${duration.minutes()}min ${duration.seconds()> 0?`${duration.seconds()}s`:''}`
    else if(durationMs >= 1000) return `${negatif}${duration.seconds()}s` //+ duration.milliseconds() + 'ms'
    else if(durationMs == 0) return  ''
    else return `${negatif}${duration.milliseconds()} ms`   
  }
}

Vue.filter('formatDuree', function(value:Array<Date>,i18n:VueI18n,forceShowSecond:boolean = false) {
  if (value && value.length >= 2 && value[0] != null && value[1] != null) {      
    const timeStart = value[0].getTime()    
    const timeEnd =  value[1].getTime()       
    return formatDuration(timeEnd - timeStart,i18n,forceShowSecond)
  }
})
Vue.filter('formatDuration',formatDuration)
